import styled from 'styled-components';
import { ContainerPreview } from '@/main/components/shared/fileUploader/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.grayLight};
  gap: 1rem;
  border-radius: 4px;
  padding: 0 0.4rem 1rem;

  ${ContainerPreview} {
    max-height: 300px;
    overflow: auto;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
  width: 100%;
`;

